import storage from '../defaultBucket';
import getCurrentUserId from '../../firebase/getCurrentUserId';

export default function getExportDownloadUrl(exportId) {
    const uid = getCurrentUserId();
    const path = `users/${uid}/exports/${exportId}`;
    return storage.ref(path).getDownloadURL();
}
